/* eslint-disable @typescript-eslint/no-explicit-any -- generic HTTP transport wrapper: body/response shapes are caller-determined. */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RestService {
  private readonly http = inject(HttpClient);

  private readonly apiUrl: string = environment.springAppUrl;

  constructor() {
    this.http.options(this.apiUrl);
  }

  public getWithOptions(url: string, options = {}): Observable<any> {
    return this.http.get(this.apiUrl + url, options);
  }

  public get(url: string, responseType?: any): Observable<any> {
    if (!responseType) {
      return this.http.get(this.apiUrl + url);
    }
    return this.http.get(this.apiUrl + url, { responseType });
  }

  public put<T = any>(url: string, body?: any) {
    return this.http.put<T>(this.apiUrl + url, body);
  }
  public post<T = any>(url: string, body: any, responseType?: any) {
    if (!responseType) {
      return this.http.post<T>(this.apiUrl + url, body);
    }

    return this.http.post<T>(this.apiUrl + url, body, {
      responseType: responseType,
    });
  }

  public delete(url: string, body?: any) {
    if (body) {
      return this.http.delete(this.apiUrl + url, { body });
    } else {
      return this.http.delete(this.apiUrl + url);
    }
  }
}
